import React, { memo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import AppText from "../Utils/AppText";

const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {AppText.confirmDeletion}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {AppText.deleteDialog}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          {AppText.cancel}
        </Button>
        <Button variant="contained" onClick={onConfirm} autoFocus>
          {AppText.yes}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(DeleteConfirmationDialog);
